import type { ProductColor } from '@aloft/toolkit-shared';
import { Flex, Icon, Tooltip, Typography } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra
import { Spinner } from '@aloft/toolkit-sui/chakra';

export type AnalysisLabelProps = {
  state: 'loading' | 'error' | 'success';
  tooltip: string;
  recommend?: string;
  color?: ProductColor;
};

export const AnalysisLabel = ({ state, tooltip, recommend, color }: AnalysisLabelProps) => (
  <Tooltip label={tooltip}>
    <Flex flexDirection="row" gap={1} alignItems="center">
      <Icon icon="sparkle" size="sm" color={color} />
      {state === 'loading' && <Spinner size="xs" />}
      {state === 'error' && <Icon icon="error-warning" size="sm" color={color} />}
      {state === 'success' && (
        <Typography inline variant="body2" color={color}>
          {recommend ?? '-'}
        </Typography>
      )}
    </Flex>
  </Tooltip>
);
